// Host -> base-path bridge.
//
// In production every FortifyID custom domain (fortifyid.com.au,
// hub.fortifyid.com.au, app.fortifyid.com.au) is attached to a SINGLE Replit
// deployment whose proxy routes by PATH, not by host:
//   /        -> marketing site (this app)
//   /app/    -> staff + ops hub
//   /verify/ -> co-branded client surface
//   /api     -> API server
//
// Because routing is path-based, a subdomain cannot be served at its own root.
// Hitting hub.fortifyid.com.au/ resolves to the "/" route (marketing). This
// bridge maps the staff/client subdomains onto their real base path so that
// hub.* lands on the staff hub and app.* on the client surface, preserving the
// rest of the path (e.g. hub.fortifyid.com.au/sign-in -> /app/sign-in).
//
// In development (and on the *.replit.app host) no subdomain prefix matches, so
// nothing is redirected and the marketing site renders normally.
const HOST_PREFIX_TO_BASE: Array<{ prefix: string; base: string }> = [
  { prefix: "hub.", base: "/app" },
  { prefix: "app.", base: "/verify" },
];

/**
 * If the current hostname is a staff/client subdomain, navigate to the matching
 * base path and return true (caller should skip rendering). Otherwise return
 * false and let the marketing app mount.
 */
export function applyHostRedirect(): boolean {
  if (typeof window === "undefined") return false;

  const host = window.location.hostname.toLowerCase();
  const match = HOST_PREFIX_TO_BASE.find(({ prefix }) => host.startsWith(prefix));
  if (!match) return false;

  const { pathname, search, hash } = window.location;
  // Already under the target base (shouldn't normally reach the marketing
  // bundle in that case, but guard against loops just in case). A bare base
  // with no trailing slash still gets canonicalized to "<base>/" below.
  if (pathname.startsWith(`${match.base}/`)) {
    return false;
  }

  const rest = pathname.replace(/^\//, "");
  window.location.replace(`${match.base}/${rest}${search}${hash}`);
  return true;
}
